/**
 * GalleryByType.tsx — Gold Garage Door / Gallery · Section 5
 * Navy · 4 door-type cards · 3 unique images each (12 total).
 *
 * IMAGE UPLOAD — 12 unique images, 3 per category.
 * Hero: 800x900 WebP @82 | Thumbs: 400x400 WebP @82.
 * Replace each CONST below after uploading to Media Library.
 *
 * 10WEB AI: keep all inline SVG + <style>. Waves intentional — do NOT strip.
 *   No lucide-react imports. No Link imports. Plain <a> tags only.
 */

// ─── SECTIONAL (Card 1) ──────────────────────────────────────────────────
const SECTIONAL_HERO = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/af6fac2d-e29d-43da-95f8-d40e8b7f8e7e.jpg?v=ee4ntchjzvu";
const SECTIONAL_THUMB1 = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/PHOTO-2026-04-13-20-04-40.webp?v=ft8uleadus";
const SECTIONAL_THUMB2 = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/b478bf77-33f2-4a5c-94b0-646707d6c1b2.jpg?v=jg5boyimbf";

// ─── INSULATED (Card 2) ──────────────────────────────────────────────────
const INSULATED_HERO = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/NZ-Door-with-Insulation-crop.jpg?v=3yn5y9c1f9s";
const INSULATED_THUMB1 = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/bd-sectional-door-insulation.webp?v=lawtk2wviof";
const INSULATED_THUMB2 = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/images.jpeg?v=uiwqxwm081";

// ─── ROLLER (Card 3) ─────────────────────────────────────────────────────
const ROLLER_HERO = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/IMG_6787-scaled.jpg?v=35dn2aspk2c";
const ROLLER_THUMB1 = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/PHOTO-2026-06-23-10-44-32.webp?v=8v5f7uf96ey";
const ROLLER_THUMB2 = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/006f6538-1cb6-4cb5-960e-762edc18976a.jpg?v=a9g7w18jfmw";

// ─── REPAIRS (Card 4) ────────────────────────────────────────────────────
const REPAIRS_HERO = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/98e6b5da-5f28-4e7a-9644-2bf8351ab70d-3.webp?v=0auyraf9i9pl";
const REPAIRS_THUMB1 = "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/ecb5a9d3-0201-404c-b545-d75f7e3bbef0.webp?v=ostwvdhum48";
const REPAIRS_THUMB2 = "https://goldgaragedoor.com.au/wp-content/uploads/2026/05/9ada9b93-909d-463a-a8f5-c673b2a6de54.webp?v=jhh9h3bqdam";
// ──────────────────────────────────────────────────────────────────────────

const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const NAVY_DEEP = "#050D24";
const GOLD = "#F5A623";
const FH = "'Plus Jakarta Sans', sans-serif";
const FB = "'Manrope', sans-serif";

/** inline SVG icons — DO NOT REPLACE WITH IMG */
const IcoLayers = () => <svg data-icon-container="lucide-do-not-replace" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"><path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" /><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65" /><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" /></svg>;
const IcoSnow = () => <svg data-icon-container="lucide-do-not-replace" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12h20M12 2v20M20 16l-4-4 4-4M4 8l4 4-4 4M16 4l-4 4-4-4M8 20l4-4 4 4" /></svg>;
const IcoRotate = () => <svg data-icon-container="lucide-do-not-replace" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /></svg>;
const IcoWrench = () => <svg data-icon-container="lucide-do-not-replace" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" /></svg>;
const IcoArrow = () => <svg data-icon-container="lucide-do-not-replace" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>;
const IcoPhone = () => <svg data-icon-container="lucide-do-not-replace" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={NAVY} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>;
const CATS = [{
  icon: <IcoLayers />,
  name: "Sectional doors",
  tagline: "The Sydney standard",
  count: "412 installed",
  href: "/garage-door-installation-sydney/",
  description: "Classic ribbed or smooth-skin panels that lift overhead — works for 90% of Sydney homes. Strong ColorBond range, smart-opener ready, fast lead time.",
  hero: SECTIONAL_HERO,
  heroAlt: "Featured B&D Panelift Icon sectional garage door install — Sydney",
  t1: SECTIONAL_THUMB1,
  t1Alt: "Sectional door close-up detail",
  t2: SECTIONAL_THUMB2,
  t2Alt: "Sectional door at dusk, Eastern Suburbs Sydney",
  bullets: ["B&D · Steel-Line · Centurion", "Most ColorBond options"]
}, {
  icon: <IcoSnow />,
  name: "Insulated doors",
  tagline: "Cool, quiet, premium",
  count: "187 installed",
  href: "/insulated-garage-doors-sydney/",
  description: "42mm polyurethane core panels engineered for Sydney summers. Up to 8°C cooler, 27dB quieter, dent-resistant. The upgrade for rooms above the garage.",
  hero: INSULATED_HERO,
  heroAlt: "Insulated double garage door, Drummoyne — Gold Garage Door",
  t1: INSULATED_THUMB1,
  t1Alt: "Insulated Steel-Line Therma-Lux installation",
  t2: INSULATED_THUMB2,
  t2Alt: "Insulated panel detail showing thermal foam core",
  bullets: ["R-2.0 thermal · STC 27+", "Marine-grade coastal options"]
}, {
  icon: <IcoRotate />,
  name: "Roller doors",
  tagline: "Compact, low-headroom",
  count: "284 installed",
  href: "/roller-door-repair-sydney/",
  description: "Curtain-style rolling doors that stack tight overhead — ideal for granny flats, inner-west terraces, and tight apartment carparks. Full ColorBond palette.",
  hero: ROLLER_HERO,
  heroAlt: "Roller garage door install, Parramatta — ColorBond Monument",
  t1: ROLLER_THUMB1,
  t1Alt: "Roller door drum detail",
  t2: ROLLER_THUMB2,
  t2Alt: "Compact roller door on inner-west terrace",
  bullets: ["EcoLift · Steel-Line · Gliderol", "Insulated slats available"]
}, {
  icon: <IcoWrench />,
  name: "Repairs & service",
  tagline: "Springs · cables · motors · panels",
  count: "364 jobs / year",
  href: "/garage-door-repair-sydney/",
  description: "Same-day repairs across Sydney for every component — broken springs, snapped cables, dead motors, bent panels, dodgy openers. Fixed-price quotes before we lift a tool.",
  hero: REPAIRS_HERO,
  heroAlt: "Garage door spring replacement in progress, Sydney technician",
  t1: REPAIRS_THUMB1,
  t1Alt: "Replacement torsion springs on garage door",
  t2: REPAIRS_THUMB2,
  t2Alt: "New garage door motor installation",
  bullets: ["1-Year Labour Warranty", "Same-day across 217+ suburbs"]
}];
export default function GalleryByType() {
  return <section id="by-type" style={{
    backgroundColor: NAVY,
    fontFamily: FB,
    paddingTop: "110px",
    paddingBottom: "110px",
    position: "relative",
    overflow: "hidden"
  }}>
      <style>{`
        .gbt-cards{display:grid;grid-template-columns:repeat(2,1fr);gap:1.25rem}
        .gbt-inner{display:grid;grid-template-columns:1.2fr 0.8fr;gap:0}
        .gbt-thumbs{display:grid;grid-template-columns:1fr 1fr;gap:6px}
        .gbt-bottom{display:flex;align-items:center;justify-content:space-between;gap:1.5rem}
        .gbt-btns{display:flex;flex-wrap:wrap;align-items:center;gap:.75rem;flex-shrink:0}
        @media(max-width:880px){.gbt-cards{grid-template-columns:1fr}.gbt-inner{grid-template-columns:1fr}.gbt-bottom{flex-direction:column;align-items:flex-start}#by-type{padding-top:70px;padding-bottom:70px}}
        @media(max-width:520px){#by-type{padding-top:50px;padding-bottom:50px}}
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      inset: 0,
      background: `radial-gradient(circle at 80% 20%,${NAVY_LIGHT}66 0%,${NAVY} 50%),radial-gradient(circle at 10% 100%,${GOLD}10 0%,transparent 40%)`
    }} />
      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}><filter id="grain-gbt"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter><rect width="100%" height="100%" filter="url(#grain-gbt)" /></svg>
      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg,transparent,${GOLD}66 50%,transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg,transparent,${GOLD}66 50%,transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      right: "-30px",
      top: "40px",
      fontFamily: FH,
      fontSize: "240px",
      fontWeight: 800,
      lineHeight: 1,
      color: `${GOLD}12`,
      userSelect: "none",
      pointerEvents: "none"
    }}>05</div>

      <div style={{
      position: "relative",
      maxWidth: "1280px",
      margin: "0 auto",
      padding: "0 1.5rem"
    }}>
        <div style={{
        marginBottom: "3.5rem",
        maxWidth: "700px"
      }}>
          <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "1.25rem"
        }}>
            <div aria-hidden style={{
            height: "1px",
            width: "48px",
            background: GOLD
          }} />
            <span style={{
            fontFamily: FH,
            fontSize: "12px",
            fontWeight: 700,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: GOLD
          }}>05 · Browse by Door Type</span>
          </div>
          <h2 style={{
          fontFamily: FH,
          fontWeight: 800,
          fontSize: "clamp(1.9rem,5vw,3.4rem)",
          lineHeight: 1.08,
          color: "#fff",
          marginBottom: "20px"
        }}>Four door types.<br /><span style={{
            color: GOLD
          }}>One that fits your driveway.</span></h2>
          <p style={{
          fontFamily: FB,
          fontSize: "17px",
          lineHeight: 1.65,
          color: "rgba(255,255,255,0.72)",
          maxWidth: "640px"
        }}>Each Sydney home has a "right" door — based on opening size, headroom, climate zone, and how you use the garage. Pick the category and dive deeper.</p>
        </div>

        <div className="gbt-cards">
          {CATS.map((c, i) => <article key={c.name} style={{
          position: "relative",
          borderRadius: "16px",
          overflow: "hidden",
          background: `${NAVY_LIGHT}55`,
          border: "1px solid rgba(255,255,255,0.08)"
        }}>
              <div aria-hidden style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "80px",
            height: "1px",
            background: `linear-gradient(90deg,${GOLD},transparent)`
          }} />
              <div className="gbt-inner">
                <div style={{
              padding: "1.75rem 2rem",
              position: "relative"
            }}>
                  <div aria-hidden style={{
                position: "absolute",
                top: "16px",
                right: "-8px",
                fontFamily: FH,
                fontSize: "70px",
                fontWeight: 800,
                color: `${GOLD}10`,
                lineHeight: 1,
                userSelect: "none",
                pointerEvents: "none"
              }}>{String(i + 1).padStart(2, "0")}</div>
                  <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "1.25rem"
              }}>
                    <span style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "44px",
                  height: "44px",
                  borderRadius: "8px",
                  background: `${GOLD}15`,
                  border: `1px solid ${GOLD}33`
                }}>{c.icon}</span>
                    <span style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "4px 10px",
                  borderRadius: "999px",
                  background: `${GOLD}15`,
                  border: `1px solid ${GOLD}33`
                }}><span style={{
                    width: 5,
                    height: 5,
                    borderRadius: "50%",
                    background: GOLD
                  }} /><span style={{
                    fontFamily: FH,
                    fontSize: "10px",
                    fontWeight: 800,
                    letterSpacing: "0.1em",
                    color: GOLD,
                    textTransform: "uppercase"
                  }}>{c.count}</span></span>
                  </div>
                  <div style={{
                fontFamily: FH,
                fontSize: "10px",
                fontWeight: 700,
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                color: GOLD,
                marginBottom: "6px"
              }}>{c.tagline}</div>
                  <h3 style={{
                fontFamily: FH,
                fontWeight: 800,
                fontSize: "1.4rem",
                lineHeight: 1.2,
                color: "#fff",
                marginBottom: "12px"
              }}>{c.name}</h3>
                  <p style={{
                fontFamily: FB,
                fontSize: "13.5px",
                lineHeight: 1.6,
                color: "rgba(255,255,255,0.72)",
                marginBottom: "14px"
              }}>{c.description}</p>
                  <div style={{
                marginBottom: "1.25rem"
              }}>{c.bullets.map(b => <div key={b} style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                  fontFamily: FH,
                  fontSize: "11.5px",
                  fontWeight: 700,
                  color: "rgba(255,255,255,0.82)",
                  marginBottom: "6px"
                }}><span style={{
                    color: GOLD,
                    marginTop: "1px",
                    flexShrink: 0
                  }}>◆</span><span>{b}</span></div>)}</div>
                  <a href={c.href} style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                fontFamily: FH,
                fontSize: "12.5px",
                fontWeight: 800,
                letterSpacing: "0.04em",
                color: GOLD,
                textDecoration: "none"
              }}>EXPLORE THE PAGE <IcoArrow /></a>
                </div>
                <div style={{
              display: "grid",
              gridTemplateRows: "1.5fr 1fr",
              gap: "6px",
              padding: "12px"
            }}>
                  <div style={{
                borderRadius: "6px",
                overflow: "hidden",
                background: "#0e1a36"
              }}><img src={c.hero} alt={c.heroAlt} width={400} height={450} loading="lazy" decoding="async" style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "150px",
                  objectFit: "cover",
                  display: "block"
                }} /></div>
                  <div className="gbt-thumbs">
                    <div style={{
                  borderRadius: "6px",
                  overflow: "hidden",
                  background: "#0e1a36"
                }}><img src={c.t1} alt={c.t1Alt} width={200} height={200} loading="lazy" decoding="async" style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "75px",
                    objectFit: "cover",
                    display: "block"
                  }} /></div>
                    <div style={{
                  borderRadius: "6px",
                  overflow: "hidden",
                  background: "#0e1a36"
                }}><img src={c.t2} alt={c.t2Alt} width={200} height={200} loading="lazy" decoding="async" style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "75px",
                    objectFit: "cover",
                    display: "block"
                  }} /></div>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <div style={{
        marginTop: "3rem",
        borderRadius: "16px",
        padding: "1.75rem 2rem",
        overflow: "hidden",
        background: `linear-gradient(135deg,${NAVY_LIGHT}AA,${NAVY_DEEP})`,
        border: `1px solid ${GOLD}33`
      }}>
          <div className="gbt-bottom">
            <div>
              <div style={{
              fontFamily: FH,
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              color: GOLD,
              marginBottom: "6px"
            }}>Not sure which type?</div>
              <h3 style={{
              fontFamily: FH,
              fontWeight: 800,
              fontSize: "clamp(1.3rem,3vw,1.85rem)",
              lineHeight: 1.2,
              color: "#fff"
            }}>Send a photo on WhatsApp — we'll tell you which fits.</h3>
            </div>
            <div className="gbt-btns">
              <a href="tel:0485000933" style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              padding: "0.85rem 1.5rem",
              borderRadius: "999px",
              background: GOLD,
              color: NAVY,
              fontFamily: FH,
              fontWeight: 700,
              fontSize: "14px",
              textDecoration: "none",
              boxShadow: `0 8px 24px ${GOLD}33`
            }}><IcoPhone /> Call 0485 000 933</a>
              <a href="https://wa.me/61485000933?text=Hi%2C%20I%27d%20like%20advice%20on%20which%20garage%20door%20type%20fits%20my%20home." target="_blank" rel="noopener noreferrer" style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "0.85rem 1.25rem",
              borderRadius: "999px",
              background: "#25D366",
              color: NAVY,
              fontFamily: FH,
              fontWeight: 700,
              fontSize: "14px",
              textDecoration: "none"
            }}>WhatsApp</a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}